import { render } from "./Migration.vue?vue&type=template&id=6d900223&scoped=true"
import script from "./Migration.vue?vue&type=script&lang=ts"
export * from "./Migration.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6d900223"

export default script